import React, { createContext, useContext } from 'react';
import type { MarketAnalyticsSnapshot } from '../../types/marketAnalytics';

const SnapshotOverrideContext = createContext<MarketAnalyticsSnapshot | null | undefined>(undefined);

/** Lets GexAnalyticsStrip / BL chart read a local snapshot instead of global RegimeContext only. */
export const RegimeSnapshotProvider: React.FC<{
  snapshot: MarketAnalyticsSnapshot | null;
  children: React.ReactNode;
}> = ({ snapshot, children }) => (
  <SnapshotOverrideContext.Provider value={snapshot}>{children}</SnapshotOverrideContext.Provider>
);

export function useAnalyticsSnapshotOverride(): MarketAnalyticsSnapshot | null | undefined {
  return useContext(SnapshotOverrideContext);
}
